<template>
  <div id="want">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toHref()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        <img src="@/assets/logo.png" width="21" height="25" style="margin-top:6px" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>
      </div>
      <div class="right" @click="toUrl('/mine')">
        <van-icon name="manager" size="21" />
      </div>
    </div>
    <div class="main padding">
      <van-swipe :autoplay="4000" indicator-color="#80BE61">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img src="@/assets/banner1.png" style="width:100%" />
        </van-swipe-item>
      </van-swipe>
      <div class="want-tit">
        <span class="yuan1"></span>
        <span class="yuan2 yuan3"></span>
        我想要
        <span class="yuan1 yuan4"></span>
        <span class="yuan2"></span>
        <van-loading size="24px" v-show="showL" style="text-align:center">加载中...</van-loading>
      </div>
      <div class="want-list">
        <ul>
          <li
            class="wants"
            v-for="(item,index) in list"
            :key="index"
            @click="toMenu(item.id,item.menu_name)"
          >
            <img :src="item.icon" />
            <span>{{item.menu_name}}</span>
          </li>
        </ul>
        <!-- <div class="wants">
          <img src="@/assets/want1.png" />
          <span>办理残疾证</span>
        </div>
        <div class="wants">
          <img src="@/assets/want2.png" />
          <span>办理残疾证</span>
        </div>
         <div class="wants">
          <img src="@/assets/want2.png" />
          <span>办理残疾证</span>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Swipe, SwipeItem, Col, Loading } from "vant";
import { wantNav, getTokenByTicket, toknStatus } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Loading.name]: Loading,
  },
  data() {
    return {
      images: ["@/assets/banner1.png", "@/assets/banner1.png"],
      list: [],
      showL: true,
      ticket: "",
      token: "",
      chatUrl: "https://qshcjr.ncscloudmedia.com/api.php",
    };
  },
  mounted() {
    let ticket = this.$route.query.ticket;
    let token = localStorage.getItem("tokenY");
    // localStorage.setItem("tokenY", 44);
    if (ticket) {
      this.ticket = ticket;
      this.getTokenByTickets();
      this.$router.push("/want");
    } else if (token) {
      this.token = token;
      this.IsTokenStatus(token);
    } else {
      var href = escape(window.location.href);
      var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
      window.location.href = url;
    }
    this.getNav();
  },
  methods: {
     // // 获取token
    getTokenByTickets() {
      //  alert(this.ticket)
      getTokenByTicket({ ticket: this.ticket }).then((res) => {
        if (res.status == 1) {
          localStorage.setItem("tokenY", res.data.token);
          this.token = res.data.token;
        } else {
          this.$router.push("/want");
          var href = escape(window.location.href);
          var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
          window.location.href = url;
        }
      });
    },
    // token是否失效
    IsTokenStatus(token) {
      toknStatus({ token: token }).then((res) => {
        if (res.status == 1) {
          this.token = token;
        } else {
          var href = escape(window.location.href);
          var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
      // alert(url)
          window.location.href = url;
        }
      });
    },
     toHref(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    toUrl(u) {
      this.$router.push(u);
    },
    getNav() {
      wantNav().then((res) => {
        // console.log(res)
        this.list = res.data;
        this.showL = false;
      });
    },
    toMenu(id, t) {
      // console.log(888)
      this.$router.push({
        path: "/wantMenu",
        query: {
          id: id,
          title: t,
        },
      });
    },
  },
};
</script>
<style scoped>
#want {
  height: 100%;
  color: black;
  /* background-color: #F3F9F6; */
}
.want-tit {
  height: 3rem;
  line-height: 3rem;
}
.yuan1,
.yuan2 {
  width: 1rem;
  height: 1rem;
  background: #9edb62;
  display: inline-block;
  border-radius: 1rem;
  top: 0.1rem;
  position: relative;
}
.yuan2 {
  background: #ecad3e;
}
.yuan3 {
  right: 0.5rem;
}
.yuan4 {
  left: 0.5rem;
}
.main {
  height: 100%;
  background: #f3f9f6;
}
.want-list {
  display: flex;
  /* padding: 1rem 0; */
  /* padding-top: 1.5rem; */
  /* border-bottom: solid 1rem #f3f9f6; */
  background: #f3f9f6;
  flex-wrap: wrap;
  padding-bottom: 1rem;
}
.want-list ul {
  width: 100%;
}
.wants {
  float: left;
  background: white;
  width: 49%;
  margin-bottom: 1rem;
  line-height: 3rem;
  position: relative;
}
.wants:nth-child(odd):after {
  /*content 可为空 必须写这句*/
  content: "";
  /*设置margin: 0 auto; 加上相对定位的left和right都为零 可让伪元素在active中水平居中*/
  margin: 0 auto;
  position: absolute;
  right: 0;
  height: 60%;
  width: 2px;
  top: 20%;

  background-color: #aaaaaa;
}
.wants img {
  width: 1.8rem;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}
.border-right {
  border-right: solid 2px #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/page/want.vue